import { render, staticRenderFns } from "./ComparisonCard.vue?vue&type=template&id=62b19ecc&scoped=true&"
import script from "./ComparisonCard.vue?vue&type=script&lang=js&"
export * from "./ComparisonCard.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonCard.vue?vue&type=style&index=0&id=62b19ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b19ecc",
  null
  
)

export default component.exports